import { render } from "./IncludeSections.vue?vue&type=template&id=57a79195&scoped=true"
import script from "./IncludeSections.vue?vue&type=script&lang=js"
export * from "./IncludeSections.vue?vue&type=script&lang=js"

import "./IncludeSections.vue?vue&type=style&index=0&id=57a79195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a79195"]])

export default __exports__